import { FIELD_TYPES } from 'src/constants/Fields';
import { GridColumns } from 'src/models/QuerybuilderModel';
import { t } from 'src/lib/language';

const tickets = [
  {
    field: 'event_tickets.id',
    minWidth: 150,
    type: FIELD_TYPES.number,
  },
  {
    field: 'event_tickets.ticket_identifier',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'products.name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'event_tickets.status',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'event_tickets.is_sent_by_email',
    minWidth: 150,
    type: FIELD_TYPES.boolean,
  },
  {
    field: 'event_tickets.is_sent_by_sms',
    minWidth: 150,
    type: FIELD_TYPES.boolean,
  },
  {
    field: 'event_tickets.sold_price',
    minWidth: 150,
    type: FIELD_TYPES.money,
  },
  {
    field: 'contacts.first_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'contacts.last_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'contacts.company_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'contacts.email',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'contacts.phone_mobile',
    minWidth: 150,
    type: FIELD_TYPES.phone,
  },
  {
    field: 'event_tickets.first_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'event_tickets.last_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'event_tickets.email',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'event_tickets.phone',
    minWidth: 150,
    type: FIELD_TYPES.phone,
  },
  {
    field: 'event_tickets.invoice_id',
    minWidth: 150,
    type: FIELD_TYPES.number,
  },
  {
    field: 'event_tickets.payment_status',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'sellers.first_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'sellers.last_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'sellers.company_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
];

export const getTicketsColumns = (columns: GridColumns, lang: string): GridColumns => {
  const contactDisplay: Record<string, string> = {
    'contacts.email': t(lang, 'fields.ticket_contacts.email'),
    'contacts.first_name': t(lang, 'fields.ticket_contacts.first_name'),
    'contacts.last_name': t(lang, 'fields.ticket_contacts.last_name'),
    'contacts.phone_mobile': t(lang, 'fields.ticket_contacts.phone_mobile'),
  };
  return columns.map((column) => {
    const localized = column.field === 'products.name'
      ? { ...column, field: `products.name_${lang}` }
      : column;
    const display = contactDisplay[localized.field];
    return display ? { ...localized, display } : localized;
  });
};

export default tickets;
